import { render, staticRenderFns } from "./TipTapImageComponent.vue?vue&type=template&id=01ee2979"
import script from "./TipTapImageComponent.vue?vue&type=script&lang=js"
export * from "./TipTapImageComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports